import '../../styles/IssueSolutionLabel.css'
import { ReactComponent as WhiteStarIcon } from '../../svg/normalSvgs/WhiteStarIcon.svg'
import { useTranslation } from 'react-i18next'

export default function IssueSolutionLabel(props) {
    const { t } = useTranslation()
    return (
        <div className="solution-item-label inline-label">
            <div className="items-center">
                <div className="mr-5 items-center">
                    <WhiteStarIcon />
                </div>
                <span className="expert-block">{t('expertRecommendation')} </span>
            </div>
        </div>
    )
}
